<template>
  <div class="app-main-content">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <fcl-addon-search-bar
        :filter="filter"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <template slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEdit" type="primary" :disabled="!this.cpSelectRow" @click="onEdit()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="deleteAllowed_CP && isActiveCpTab" no="onDeleteCP" type="danger" @click="onDelete_CP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-show="!isActiveCpTab" no="onDeletePP" type="danger" @click="onDelete_PP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-show="approveAllowed_PP && !isActiveCpTab" no="onApprovePP" type="primary" @click="onApprove_PP()">{{ $t('Pricing.Approve') }}</el-button>
          <el-button v-show="inputAllowed_PP && !isActiveCpTab" no="onAdd" type="primary" @click="onAdd()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-show="inputAllowed_PP && !isActiveCpTab" no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-show="inputAllowed_PP && !isActiveCpTab"
            no="saveExcelFile"
            :action="URL.price.priceFclAddon.saveExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadExcelSuccess"
            :data="{currentOfficeId:$store.getters.currentOfficeId}"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
      </fcl-addon-search-bar>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.CurrentPrice')" name="cpList">
          <fcl-addon-data-grid
            :v-if="activeTabName === 'cpList'"
            config-module="223101"
            :show-approve="true"
            :row-data="rowCpData"
            :grid-options="cpGridOptions"
            @selectRowChange="selectRowChange"
          />
          <div ref="txtCpRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
            <textarea v-model="txtCpRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.PendingPrice')" name="ppList">
          <fcl-addon-data-grid
            :v-if="activeTabName === 'ppList'"
            config-module="223102"
            :show-approve="false"
            :show-selection="true"
            :row-data="rowPpData"
            :grid-options="ppGridOptions"
            @selectRowChange="selectRowChange"
          />
          <div ref="txtPpRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
            <textarea v-model="txtPpRemarks" no="txtPpRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <fcl-addon-form
      :visible="fclAddonFormDialog.visible"
      :price="fclAddonFormDialog.ss"
      :is-new="fclAddonFormDialog.isNew"
      @close="onShippingScheduleFormDialogClose"
      @reload="toQuery"
    />
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import { queryPriceFclAddon, deletePriceFclAddons, approvePriceFclAddons } from '@/api/price/priceFclAddon'
import DateUtils from '@/utils/dateUtils'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import LocalStorageUtils from '@/utils/localStorageUtils'
import FclAddonSearchBar from '@/views/cargo/v0/Price/components/query/fclAddonSearchBar'
import FclAddonDataGrid from '@/views/cargo/v0/Price/PriceFclAddon/components/fclAddonDataGrid'
import FclAddonForm from '@/views/cargo/v0/Price/PriceFclAddon/components/fclAddonForm'

export default {
  name: 'PriceFclAddon',
  components: {
    FclAddonForm,
    FclAddonDataGrid,
    FclAddonSearchBar },
  data() {
    return {
      URL,
      isAdminOrHQ: false,
      remarkChange: '',
      targetLevel: 99,
      txtCpRemarks: '',
      txtPpRemarks: '',
      activeTabName: 'cpList',
      showDetail: false,
      cpSelectRow: {}, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      rowCpData: [],
      rowPpData: [],
      fullscreenLoading: null,
      proxy: {},
      filter: {
        pol: '',
        pod: '',
        carrier: '',
        createdBy: 0,
        branch: 0,
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: ''
      },
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent
      },
      fclAddonFormDialog: {
        visible: false,
        ss: {},
        isNew: false
      },
      approveAllowed_PP: false,
      deleteAllowed_PP: false,
      deleteAllowed_CP: false,
      inputAllowed_PP: false,
      priceFclUtil: null,
      pgsLMap: {}
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    sessionId() {
      return this.$store.getters.token
    },
    isActiveCpTab() {
      return this.activeTabName === 'cpList'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('SurchargeFCL', val)
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      this.isAdminOrHQ = MultiCompanyUtil.getInstance().isAdminOrHQ2('PriceFcl')
      this.priceFclUtil = await PricingFCLConfigUtil.getInstance()
      this.pgsLMap = await this.priceFclUtil.getPolPrivileges()
      if (this.isAdminOrHQ) {
        this.approveAllowed_PP = true
        this.deleteAllowed_PP = true
        this.deleteAllowed_CP = true
        this.inputAllowed_PP = true
      } else {
        this.approveAllowed_PP = this.deleteAllowed_CP = this.priceFclUtil.isApprove
        this.inputAllowed_PP = this.priceFclUtil.isInput
      }
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      console.log(tab, event)
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    onShippingScheduleFormDialogClose() {
      this.fclAddonFormDialog.visible = false
      this.fclAddonFormDialog.data = {}
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      this.proxy['state'] = this.isActiveCpTab ? PriceConstant.PRICE_STATE_EFFECTIVE : PriceConstant.PRICE_STATE_PENDING
      queryPriceFclAddon(this.proxy).then((res) => {
        this.loadingEnd()
        const rowData = res.data
        if (rowData && rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
          return
        }
        if (rowData.length > PriceConstant.MAX_QUERY_COUNT) {
          rowData.pop() // 删除第PriceConstant.MAX_QUERY_COUNT+1条
          this.$message.warning(this.$t('Pricing.MaxQueryCount'))
        }
        this.setRowData(rowData)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    setRowData(result) {
      if (this.isActiveCpTab) {
        this.rowCpData = result
      } else {
        this.rowPpData = result
      }
    },
    onGridRowClickedEvent(e) {
      const data = e.data
      this.selectRowChange(data)
      if (this.isActiveCpTab) {
        this.txtCpRemarks = data.remarks
        this.cpSelectRow = data
      } else {
        this.txtPpRemarks = data.remarks
        this.ppSelectRow = data
      }
    },
    loadingEnd() {
      const api = this.getGridOptionsApi()
      api.clearFocusedCell()
      if (this.isActiveCpTab) {
        this.txtCpRemarks = ''
      } else {
        this.txtPpRemarks = ''
      }
      this.cpSelectRow = null
      this.ppSelectRow = null
      this.fullscreenLoading.close()
    },
    getGridOptionsApi() {
      return this.isActiveCpTab ? this.cpGridOptions.api : this.ppGridOptions.api
    },
    onRowDoubleClicked(e) {
      const data = e.data
      this.selectRow = data
      this.edit(data)
    },
    onEdit() {
      this.edit(this.selectRow)
    },
    onDelete_CP() {
      // const cpSelectRow = this.cpSelectRow
      // if (!cpSelectRow) {
      //   this.$message.warning(this.$t('Pricing.NoRecordSelect'))
      //   return
      // }
      // if (!this.$store.getters.isAdmin) {
      //   if (!this.pgsLMap.hasOwnProperty(cpSelectRow.pol)) {
      //     this.$message.warning(StrUtils.substitute(this.$t('Pricing.IsDeleteRecord'), [cpSelectRow.pol, cpSelectRow.pod]))
      //     return
      //   }
      // }
      // this.$confirm(this.$t('Pricing.IsDeleteRecord'), this.$t('Message.Prompt'), {
      //   confirmButtonText: this.$t('common.btn.ok'),
      //   cancelButtonText: this.$t('common.btn.cancel'),
      //   type: 'warning'
      // }).then(() => {
      //   this.fullscreenLoading = getLoading()
      //   const ids = []
      //   ids.push(cpSelectRow.uuid)
      //   const selectRows = []
      //   selectRows.push(cpSelectRow)
      //   this.toDel(cpSelectRow, ids)
      // })

      // CARGO-33193 ID：100 利通 拼箱ADDON运价输入，查询出来勾选点击删除会提醒：没有选择数据
      const selectedRows = this.getSelectedRows()
      if (!selectedRows) {
        return
      }
      if (!this.$store.getters.isAdmin) {
        for (const item of selectedRows) {
          if (!this.pgsLMap.hasOwnProperty(item.pol)) {
            this.$message.warning(StrUtils.substitute(this.$t('Pricing.IsAllowedOperate'), [item.pol, item.pod]))
            return
          }
        }
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecord'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        const uuids = this.getSelectUuids(selectedRows)
        this.toDel(selectedRows, uuids)
      })
    },
    onDelete_PP() {
      const selectedRows = this.getSelectedRows()
      if (!selectedRows) return
      for (const item of selectedRows) {
        if (!(this.deleteAllowed_PP || item.createdBy === this.$store.getters.userInfo.userId)) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      if (selectedRows === null) {
        return
      }
      const message = selectedRows.length > 1 ? this.$t('Pricing.IsDeleteRecords') : this.$t('Pricing.IsDeleteRecord')
      this.$confirm(message, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.toDel(selectedRows, uuids)
      })
    },
    toDel(selectRows, uuids) {
      this.fullscreenLoading = getLoading()
      deletePriceFclAddons(uuids).then(res => {
        this.$message.success(this.$t('Pricing.HasDeleted'))
        this.loadingEnd()
        const api = this.getGridOptionsApi()
        api.updateRowData({ remove: selectRows })
      })
    },
    // 获取待审核的勾选数据
    getSelectedRows() {
      const api = this.getGridOptionsApi()
      console.info('api:', api)
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    edit(selectRow) {
      if (!this.inputAllowed_PP) return
      if (!selectRow) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.fclAddonFormDialog.visible = true
      this.fclAddonFormDialog.isNew = false
      this.fclAddonFormDialog.ss = selectRow
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    onAdd() {
      this.fclAddonFormDialog.visible = true
      this.fclAddonFormDialog.isNew = true
      this.fclAddonFormDialog.ss = {
        state: PriceConstant.PRICE_STATE_PENDING,
        currency: 'USD',
        eqType: 'GP',
        endDate: new Date(2050, 11, 31),
        priceDateType: 'M'
      }
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('FCL_Addon_sample.xls', 'price')
    },
    selectRowChange(data) {
      this.selectRow = data
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        if (result === '') {
          this.$message.error(this.$t('Pricing.NoRecordUpload'))
          return
        }
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          const tmp = result.split(':')
          msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
          msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        }
        return false
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      const msg = {
        dangerouslyUseHTMLString: true,
        message: failResult.replace(/\n\t/g, '<br/>'),
        type: 'error',
        duration: 5000
      }
      this.$message.error(msg)
    },
    onTxtRemarksDoubleClick() {
      this.$nextTick(() => {
        const remark = (this.isActiveCpTab) ? 'txtCpRemarks' : 'txtPpRemarks'
        const remarkChange = (this.isActiveCpTab) ? this.remarkCpChange : this.remarkPpChange
        this.$refs[remark].style.height = !remarkChange ? '30%' : '6%'
        if (this.isActiveCpTab) {
          this.remarkCpChange = !this.remarkCpChange
        } else {
          this.remarkPpChange = !this.remarkPpChange
        }
      })
    },
    onApprove_PP() {
      const selectedRows = this.getSelectedRows()
      if (!this.$store.getters.isAdmin) {
        for (const row of selectedRows) {
          if (!this.pgsLMap.hasOwnProperty(row.pol)) {
            this.$message.warning(StrUtils.substitute(this.$t('Pricing.IsAllowedOperate'), [row.pol, row.pod]))
            return
          }
        }
      }
      const message = selectedRows.length > 1 ? this.$t('Pricing.IsApproveRecords') : this.$t('Pricing.IsApproveRecord')
      this.$confirm(message, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        approvePriceFclAddons(selectedRows).then(res => {
          this.$message.success(this.$t('Pricing.HasApproved'))
          this.loadingEnd()
          const api = this.getGridOptionsApi()
          api.updateRowData({ remove: selectedRows })
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
